import { render, staticRenderFns } from "./goodsWarning.vue?vue&type=template&id=5f1bbb2a&scoped=true"
import script from "./goodsWarning.vue?vue&type=script&lang=js"
export * from "./goodsWarning.vue?vue&type=script&lang=js"
import style0 from "./goodsWarning.vue?vue&type=style&index=0&id=5f1bbb2a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f1bbb2a",
  null
  
)

export default component.exports